import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import AddBar from "../views/AddBar.vue";
import AllBars from "../views/AllBars.vue";
import EditBar from "../views/EditBar.vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "manage",
    component: Login
  },
  {
    path: "/add-bar",
    name: "add-bar",
    component: AddBar,
    beforeEnter(to, from, next) {
      if (store.state.loggedIn) {
        next();
      } else {
        next({ name: "manage" });
      }
    }
  },
  {
    path: "/all-bars",
    name: "all-bars",
    component: AllBars,
    beforeEnter(to, from, next) {
      if (store.state.loggedIn) {
        next();
      } else {
        next({ name: "manage" });
      }
    }
  },
  {
    path: "/edit-bar",
    name: "edit-bar",
    component: EditBar,
    beforeEnter(to, from, next) {
      if (store.state.loggedIn) {
        next();
      } else {
        next({ name: "manage" });
      }
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
